import React from "react";
import styles from "./index.module.scss";
import { Dialog } from "primereact/dialog";
import Buttonc from "../button";

interface PropTypes {
  cancelVisible: boolean;
  setCancelVisible: React.Dispatch<React.SetStateAction<boolean>>;
  buttonLabel: string;
  message: string;
  header: string;
  loading: boolean;
  onClick: () => void;
}

export default function LogoutDialog({
  cancelVisible,
  setCancelVisible,
  buttonLabel,
  message,
  header,
  loading,
  onClick
}: PropTypes) {
  return (
    <Dialog
      visible={cancelVisible}
      closable={false}
      closeOnEscape={true}
      header={header}
      dismissableMask={true}
      onHide={() => {
        setCancelVisible(false);
      }}
      className={styles.dialog}
      draggable={false}
      resizable={false}
    >
      <div className={styles.message}>{message}</div>
      <div className={styles.btnWrap}>
        <Buttonc
          btnType="border"
          type="submit"
          tabIndex={7}
          size="small"
          className={styles.cancelBtn}
          label={"Cancel"}
          disabled={loading}
          onClick={() => {
            setCancelVisible(false);
          }}
        />
        <Buttonc
          type="submit"
          tabIndex={7}
          size="small"
          label={buttonLabel}
          loading={loading}
          onClick={onClick}
          className={styles.subBtn}
        />
      </div>
    </Dialog>
  );
}
